export const ABS_SELECTION: string = "Attribute-Based Selection";
export const CF_SELECTION: string = "Collection Filtering";
export const ABS_CATE: string = "accordionFlushCate";
export const CF_CATE: string = "accordionFlushCf";
export const ABS_COLLAPSE: string = "#flush-collapseCat";
export const CF_COLLAPSE: string = "#flush-collapseCf";
export const ABS_ACTIVATE_MESSAGE: string = "Activate this attribute for ABS";
export const CF_ACTIVATE_MESSAGE: string = "Activate this attribute for CF";
export const ABS_VALUE: string = "ABS Display value";
export const CF_VALUE: string = "CF Display value";